import(/* webpackMode: "eager" */ "/app/src/app/page.tsx");
